<template>
  <div>
    <base-title title="Juno" subtitle="Integrações" link="integracoes" />

    <div class="integration-details">
      <div class="header">
        <div class="wrapper">
          <p class="title">Sobre a Juno</p>
          <img
            src="@/assets/img/integration.svg"
            class="img-fluid mobile"
            alt="Integrações"
          />
          <p class="description">
            A Juno é uma intermediadora de pagamentos, o que quer dizer que
            várias empresas usam os nossos serviços para emitir cobranças e
            receber pagamentos. Então, se você encontrou um DDA em nosso nome na
            sua conta, provavelmente é porque fez alguma compra recentemente com
            alguma das empresas que trabalha com a nossa plataforma. Receba
            pagamentos online por boleto bancário ou cartão de crédito com seu
            CPF, sem precisar de conta jurídica e profissionalize seu negócio.
            Pagamento profissional para pessoas físicas – mais proteção contra
            fraudes e calotes – comece a cobrar seus clientes com boleto e
            cartão de crédito hoje mesmo.
          </p>
        </div>
        <img
          src="@/assets/img/integration.svg"
          class="img-fluid desktop"
          alt="Integrações"
        />
      </div>

      <div class="register">
        <base-button
          text="Configurar"
          class="big w-100"
          @click="changeRoute('juno-token')"
        />

        <div class="help">
          <p>Tem dúvidas? Acesse&nbsp;</p>
          <a
            href="https://ajuda.easydelivery.com.br/apis-e-integracoes/"
            target="_blank"
            class="link"
            >https://ajuda.easydelivery.com.br/</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// styles
import '@/assets/css/veasy/integrations.css';
// components
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
// mixins
import junoConfiguration from '@/mixins/junoConfiguration.js';

export default {
  mixins: [junoConfiguration],
  data() {
    return {
      seeMoreAbout: false,
      seeMoreConditions: false,
    };
  },
  components: {
    BaseTitle,
    BaseButton,
  },
};
</script>
